<template lang="pug">
  b-modal(
    ref="modal-delete-property"
    id="modal-delete-property"
    hide-footer
    hide-header
  )
    .title 
      i.fas.fa-exclamation-triangle
      span {{ $t('property_list_page.confirm_delete') }}
      a.close-modal(href="#" @click="hideModal") ×
    .message {{ name }} {{ $t("property_list_page.want_to_delete") }}
    .actions
      button.cancel(@click="hideModal") {{ $t("property_list_page.cancel") }}
      button.delete(@click="deleteProperty") {{ $t("property_list_page.delete") }}
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        default: ''
      }
    },

    methods: {
      hideModal() {
        this.$emit('cancelDelete')
        this.$refs['modal-delete-property'].hide()
      },

      deleteProperty() {
        this.$emit('acceptDelete')
        this.$refs['modal-delete-property'].hide()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    margin-bottom: 30px;

    .fa-exclamation-triangle {
      color: #de3509;
      font-size: 20px;
      margin: 15px 10px 10px 10px;
      opacity: 0.8;
    }
  }

  .close-modal {
    color: #313541;
    float: right;
    font-weight: 700;
    opacity: 0.3;
    text-decoration: none;
  }

  .close-modal:hover {
    opacity: 0.5;
  }

  .message {
    color: #3d4a57;
    font-size: 24px;
    letter-spacing: 0;
    margin-bottom: 50px;
    text-align: center;
  }

  .actions {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;

    .delete {
      background-image: linear-gradient(270deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
      border: 0;
      border-radius: 4px;
      color: #fff;
      font-size: 14px;
      letter-spacing: 0;
      outline: 0;
      padding: 9px 40px;
    }

    .cancel {
      background-color: transparent;
      border: 0;
      color: #009cea;
      font-size: 14px;
      letter-spacing: 0;
      outline: 0;
      padding: 9px 40px;
    }
  }
</style>
